module.exports = __webpack_public_path__ + "img/logo-new.44d99d12.png";